var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntermediateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31738 1C10.1873 1 12.6553 3.16392 12.6553 6C12.6553 8.83608 10.1873 11 7.31738 11C4.44759 10.9999 1.98047 8.836 1.98047 6C1.98047 3.164 4.44759 1.00013 7.31738 1Z",
    stroke: "#183059",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.31702,
    cy: 6,
    rx: 2.16858,
    ry: 2,
    fill: "#183059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediateIcon);
export default __webpack_public_path__ + "static/media/intermediate_icon.f0388b27fa96b54d292be24d152c928e.svg";
export { ForwardRef as ReactComponent };